import { Divider, Grid, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Input, InputAuto, InputDate, Select } from "../../controls";
import { DropLi, Model, UseForm } from "../../hooks";
import { Alert, Form, Tabs } from "../../layout";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { RmvEmptyProp, ToFormData } from "../../hooks/Method";
import { useTranslation } from "react-i18next";

const AddEditInquiry = (props) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { Gender } = DropLi();
  const { InquiryMdl } = Model();
  const { branch, authUser } = useContext(AppContext);
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
    handleInpDate,
  } = UseForm(InquiryMdl);
  const [cities, setCities] = useState([]);
  const [inqSrcs, setInqSrcs] = useState([]);
  const [subsTypes, setSubsTypes] = useState([]);
  const [subsPlans, setSubsPlans] = useState([]);
  const [selTypePlans, setSelTypePlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    id &&
      API(endpoints.Inquiry + actions.GetById).getById(id, (res) => {
        if (res && res.status === 200 && res.result) {
          setValues((x) => ({ ...x, ...RmvEmptyProp(res.result) }));
        }
      });
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (branch.id) {
      API(endpoints.City + actions.GetAllByOrg).getById(
        branch.orgId,
        (res) =>
          res &&
          res.status === 200 &&
          setCities([...res.result.map((j) => ({ ...j, label: j.name }))])
      );
      API(endpoints.InqSrc + actions.GetAllByBranch).getById(
        branch.id,
        (res) =>
          res &&
          res.status === 200 &&
          setInqSrcs([...res.result.map((j) => ({ ...j, label: j.name }))])
      );
      API(endpoints.SubsType + actions.GetAllByBranch).getById(
        branch.id,
        (res) =>
          res &&
          res.status === 200 &&
          setSubsTypes([
            ...res.result.map((j) => ({ id: j.id, label: j.name })),
          ])
      );
      API(endpoints.SubsPlan + actions.GetAllByBranch).getById(
        branch.id,
        (res) =>
          res &&
          res.status === 200 &&
          setSubsPlans([...res.result.map((j) => ({ ...j, label: j.name }))])
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  useEffect(() => {
    setSelTypePlans([
      ...subsPlans.filter((j) => j.subsTypeId === values.subsTypeId),
    ]);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.subsTypeId, subsPlans]);

  const handleSubType = (e) => {
    values.subsPlanId = "";
    handleInpChg(e);
  };

  const validateForm = () => {
    let temp = {};
    temp.firstName = values.firstName !== "" ? "" : "First Name is required.";
    temp.lastName = values.lastName !== "" ? "" : "Last Name is required.";
    temp.gender = values.gender !== "" ? "" : "Gender is required.";
    temp.mobile = values.mobile !== "" ? "" : "Mobile is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && (res.status === 201 || res.status === 200)) {
          setAlert({
            isOpen: true,
            type: "success",
            title: "Success",
            subTitle: `Inquiry ${id ? "Update" : "Added"} Successfully.`,
            onClick: () => navigate("/inquiries"),
          });
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };
      if (values.id === 0) {
        values.branchId = branch.id;
        values.orgId = branch.orgId;
        values.addedUserId = authUser.id;
        API(endpoints.Inquiry + actions.Post).post(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );
      } else
        API(endpoints.Inquiry + actions.Put).put(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="mb-10 d-flex j-between a-center pt-15 pl-15 pr-15">
            <div>
              <h1
                variant="h5"
                className="form-title mb-5 fw-4 gray-color tx-upp
                    border-left"
              >
                {id ? t("Edit") : t("Add")} {t("Inquiry")}
              </h1>
            </div>

            <div>
              <Button type="submit" loading={loading}>
                {id ? t("SaveChanges") : t("Submit")}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="pl-15 pr-15 pb-15">
            <Tabs
              className="mt-30"
              header={[
                { label: t("GeneralFields"), icon: "" },
                { label: t("AdditionalFields"), icon: "" },
              ]}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={4.5}>
                  <Input
                    label={t("FirstName")}
                    name="firstName"
                    required={true}
                    value={values.firstName}
                    error={errors.firstName}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={4.5}>
                  <Input
                    label={t("LastName")}
                    name="lastName"
                    required={true}
                    value={values.lastName}
                    error={errors.lastName}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Select
                    label={t("Gender")}
                    name="gender"
                    required={true}
                    value={values.gender}
                    error={errors.gender}
                    onChange={handleInpChg}
                    options={Gender}
                  />
                </Grid>
                <Grid item xs={12} md={4.5}>
                  <Input
                    label={t("Phone")}
                    name="phone"
                    required={true}
                    value={values.phone}
                    error={errors.phone}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={4.5}>
                  <InputAuto
                    label={t("City")}
                    name="cityId"
                    required={true}
                    value={values.cityId}
                    error={errors.cityId}
                    onChange={handleInpChg}
                    options={cities}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <InputAuto
                    label={t("SourceOfInquiry")}
                    name="inqSrcId"
                    required={true}
                    value={values.inqSrcId}
                    error={errors.inqSrcId}
                    onChange={handleInpChg}
                    options={inqSrcs}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Input
                    label={t("Remark")}
                    name="remark"
                    required={true}
                    value={values.remark}
                    error={errors.remark}
                    onChange={handleInpChg}
                    multiline
                    rows={3}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("Email")}
                    name="email"
                    value={values.email}
                    error={errors.email}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3.5}>
                  <InputAuto
                    label={t("SubscriptionType")}
                    name="subsTypeId"
                    value={values.subsTypeId}
                    error={errors.subsTypeId}
                    onChange={handleSubType}
                    options={subsTypes}
                  />
                </Grid>
                <Grid item xs={12} md={3.5}>
                  <InputAuto
                    label={t("SubscriptionPlan")}
                    name="subsPlanId"
                    value={values.subsPlanId}
                    error={errors.subsPlanId}
                    onChange={handleInpChg}
                    disabled={selTypePlans.length ? false : true}
                    options={selTypePlans}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <InputDate
                    label={t("InquiryDate")}
                    name="inqDate"
                    value={values.inqDate}
                    error={errors.inqDate}
                    onChange={(date) =>
                      handleInpDate(
                        "inqDate",
                        new Date(date).toLocaleDateString()
                      )
                    }
                  />
                </Grid>
              </Grid>
            </Tabs>
          </div>
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default AddEditInquiry;
